(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5288],{

/***/ 9341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/stack/stack.mjs + 2 modules
var stack = __webpack_require__(3712);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/image/image.mjs + 2 modules
var image_image = __webpack_require__(32761);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/flex/flex.mjs
var flex = __webpack_require__(88329);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/typography/text.mjs
var typography_text = __webpack_require__(90092);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/spacer/spacer.mjs
var spacer = __webpack_require__(14114);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/box/box.mjs
var box = __webpack_require__(68029);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/badge/badge.mjs
var badge = __webpack_require__(74032);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/typography/heading.mjs
var heading = __webpack_require__(50232);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/button/button.mjs + 3 modules
var button_button = __webpack_require__(38488);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/spinner/spinner.mjs
var spinner = __webpack_require__(48899);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/utils/dist/esm/cx.mjs
var cx = __webpack_require__(34926);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/system/forward-ref.mjs
var forward_ref = __webpack_require__(49381);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/system/factory.mjs + 8 modules
var factory = __webpack_require__(17997);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/react/dist/esm/wrap/wrap.mjs
'use client';






const Wrap = (0,forward_ref/* forwardRef */.G)(function Wrap2(props, ref) {
  const {
    spacing = "0.5rem",
    spacingX,
    spacingY,
    children,
    justify,
    direction,
    align,
    className,
    shouldWrapChildren,
    ...rest
  } = props;
  const _children = (0,react.useMemo)(
    () => shouldWrapChildren ? react.Children.map(children, (child, index) => /* @__PURE__ */ (0,jsx_runtime.jsx)(WrapItem, { children: child }, index)) : children,
    [children, shouldWrapChildren]
  );
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(factory/* chakra.div */.m.div, { ref, className: (0,cx.cx)("chakra-wrap", className), ...rest, children: /* @__PURE__ */ (0,jsx_runtime.jsx)(
    factory/* chakra.ul */.m.ul,
    {
      className: "chakra-wrap__list",
      __css: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: justify,
        alignItems: align,
        flexDirection: direction,
        listStyleType: "none",
        gap: spacing,
        columnGap: spacingX,
        rowGap: spacingY,
        padding: "0"
      },
      children: _children
    }
  ) });
});
Wrap.displayName = "Wrap";
const WrapItem = (0,forward_ref/* forwardRef */.G)(
  function WrapItem2(props, ref) {
    const { className, ...rest } = props;
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(
      factory/* chakra.li */.m.li,
      {
        ref,
        __css: { display: "flex", alignItems: "flex-start" },
        className: (0,cx.cx)("chakra-wrap__listitem", className),
        ...rest
      }
    );
  }
);
WrapItem.displayName = "WrapItem";



// EXTERNAL MODULE: ./src/components/Icon.tsx
var Icon = __webpack_require__(73064);
// EXTERNAL MODULE: ./src/components/Layout.tsx + 19 modules
var Layout = __webpack_require__(73863);
// EXTERNAL MODULE: ./src/components/LinkWithQuery.tsx
var LinkWithQuery = __webpack_require__(69091);
// EXTERNAL MODULE: ./node_modules/@fusion-icons/react/interface/esm/index.js + 297 modules
var esm = __webpack_require__(52597);
// EXTERNAL MODULE: ./src/models/StrategyUrls.tsx
var StrategyUrls = __webpack_require__(82649);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 6 modules
var useQuery = __webpack_require__(67848);
// EXTERNAL MODULE: ./node_modules/isomorphic-fetch/fetch-npm-browserify.js
var fetch_npm_browserify = __webpack_require__(94301);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var index_esm = __webpack_require__(86893);
// EXTERNAL MODULE: ./src/pages/learn-about-calc/LearningHubLinks.tsx
var LearningHubLinks = __webpack_require__(6935);
;// CONCATENATED MODULE: ./src/pages/create-strategy/index.page.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















function InfoPanel() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(stack/* Stack */.K, {
    direction: "row",
    layerStyle: "panel",
    p: 4,
    spacing: 4,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(image_image/* Image */.E, {
      src: "/images/iceblock.svg"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(flex/* Flex */.k, {
      alignItems: "center",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(typography_text/* Text */.x, {
        textStyle: "body",
        children: "Remember, marketing material is typically designed to make you feel emotional and impulsive. Don't let fear and hype make your decisions for you."
      })
    })]
  });
}

function StrategyCard(_ref) {
  var name = _ref.name,
      description = _ref.description,
      advanced = _ref.advanced,
      icon = _ref.icon,
      href = _ref.href,
      learnMoreHref = _ref.learnMoreHref,
      enabled = _ref.enabled;

  var _useRouter = (0,router.useRouter)(),
      query = _useRouter.query;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(stack/* Stack */.K, {
    direction: ['row', null, null, 'column'],
    p: 4,
    layerStyle: "panel",
    width: ['full', null, null, 56],
    gap: 4,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(flex/* Flex */.k, {
      direction: "column",
      flexGrow: 1,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(flex/* Flex */.k, {
        mb: 4,
        children: [icon, /*#__PURE__*/(0,jsx_runtime.jsx)(spacer/* Spacer */.L, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(box/* Box */.x, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(badge/* Badge */.C, {
            size: "xs",
            colorScheme: advanced ? 'blue' : undefined,
            children: advanced ? 'Advanced Strategy' : 'Basic Strategy'
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(heading/* Heading */.X, {
        size: "md",
        mb: 2,
        children: name
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(typography_text/* Text */.x, {
        textStyle: "body-xs",
        children: description
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(flex/* Flex */.k, {
      justifyContent: "center",
      direction: "column",
      alignContent: "center",
      children: [enabled ? /*#__PURE__*/(0,jsx_runtime.jsx)(LinkWithQuery/* default */.Z, {
        href: {
          pathname: href !== null && href !== void 0 ? href : '',
          query: query
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(button_button/* Button */.z, {
          mb: 2,
          children: "Get started"
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(button_button/* Button */.z, {
        mb: 2,
        cursor: "unset",
        color: "navy",
        colorScheme: "grey",
        children: "Coming soon"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkWithQuery/* default */.Z, {
        href: learnMoreHref,
        passHref: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(button_button/* Button */.z, {
          as: "a",
          target: "_blank",
          colorScheme: "blue",
          variant: "ghost",
          children: "Learn more"
        })
      })]
    })]
  });
}

StrategyCard.defaultProps = {
  enabled: false,
  href: undefined,
  advanced: false
};

function useFearAndGreed() {
  var _useQuery = (0,useQuery/* useQuery */.a)(['fear-and-greed-index'], /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var response;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch("https://api.alternative.me/fng/");

          case 2:
            response = _context.sent;

            if (response.ok) {
              _context.next = 5;
              break;
            }

            throw new Error('Failed to fetch fear and greed index.');

          case 5:
            return _context.abrupt("return", response.json());

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }))),
      data = _useQuery.data,
      isLoading = _useQuery.isLoading;

  return {
    index: data === null || data === void 0 ? void 0 : data.data[0].value,
    classification: data === null || data === void 0 ? void 0 : data.data[0].value_classification,
    isLoading: isLoading
  };
}

function FearGreedStrategyRecommendation(_ref3) {
  var isAccumulation = _ref3.isAccumulation;

  var _useFearAndGreed = useFearAndGreed(),
      index = _useFearAndGreed.index,
      classification = _useFearAndGreed.classification,
      isLoading = _useFearAndGreed.isLoading;

  var setStrategyRecommendation = isAccumulation ? 'accumulation' : 'take profit';
  return /*#__PURE__*/(0,jsx_runtime.jsx)(badge/* Badge */.C, {
    colorScheme: "green",
    px: 4,
    py: 1,
    layerStyle: "panel",
    whiteSpace: "normal",
    bg: "deepHorizon",
    textAlign: "center",
    children: isLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)(spinner/* Spinner */.$, {
      w: 3,
      h: 3
    }) : index ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: ["According to the", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(LinkWithQuery/* default */.Z, {
        passHref: true,
        href: "https://alternative.me/crypto/fear-and-greed-index/",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(typography_text/* Text */.x, {
          as: "a",
          textDecoration: "underline",
          target: "_blank",
          children: "Fear & Greed index score"
        })
      }), ": ", index, " (", classification, "), it may be a good time to use ", setStrategyRecommendation, " strategies"]
    }) : null
  });
}

function Strategies() {
  var _useFearAndGreed2 = useFearAndGreed(),
      index = _useFearAndGreed2.index;

  var showFearAndGreedAccumulate = index < 41;
  var showFearAndGreedProfit = index > 59;

  function accumulationStrategies() {
    return [{
      name: 'Standard DCA In',
      description: 'Customise your own dollar-cost average buying strategy.',
      icon: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
        stroke: "white",
        strokeWidth: 2,
        as: esm/* Fullscreen2Icon */.ym1,
        width: 8,
        height: 8
      }),
      enabled: true,
      href: StrategyUrls/* default.DCAIn */.Z.DCAIn,
      learnMoreHref: LearningHubLinks/* LearningHubLinks.Dca */.B.Dca
    }, {
      name: 'Weighted Scale In',
      description: 'Buy more when the price is low, and less when the price is high.',
      advanced: true,
      enabled: true,
      icon: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
        stroke: "white",
        strokeWidth: "px",
        as: index_esm/* FiDivide */.JnT,
        width: 8,
        height: 8
      }),
      href: StrategyUrls/* default.WeightedScaleIn */.Z.WeightedScaleIn,
      learnMoreHref: LearningHubLinks/* LearningHubLinks.WeightedScale */.B.WeightedScale
    }, {
      name: 'Streaming Swap',
      description: 'Reduce slippage by swapping smaller amounts over time.',
      advanced: false,
      enabled: true,
      icon: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
        stroke: "white",
        strokeWidth: "px",
        as: index_esm/* FiAperture */.Ry6,
        width: 8,
        height: 8
      }),
      href: StrategyUrls/* default.StreamingSwap */.Z.StreamingSwap,
      learnMoreHref: LearningHubLinks/* LearningHubLinks.MoreAboutCalc */.B.MoreAboutCalc
    }];
  }

  function takeProfitStrategies() {
    return [{
      name: 'Standard DCA Out',
      description: 'Dollar-cost average out of an asset with ease.',
      icon: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
        stroke: "white",
        strokeWidth: 2,
        as: esm/* Fullscreen1Icon */.KZX,
        width: 8,
        height: 8
      }),
      enabled: true,
      href: StrategyUrls/* default.DCAOut */.Z.DCAOut,
      learnMoreHref: LearningHubLinks/* LearningHubLinks.Dca */.B.Dca
    }, {
      name: 'Weighted Scale Out',
      description: 'Sell more when the price is high, and less when the price is low.',
      advanced: true,
      enabled: true,
      href: StrategyUrls/* default.WeightedScaleOut */.Z.WeightedScaleOut,
      icon: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
        stroke: "white",
        strokeWidth: "px",
        as: index_esm/* FiDivide */.JnT,
        width: 8,
        height: 8
      }),
      learnMoreHref: LearningHubLinks/* LearningHubLinks.WeightedScale */.B.WeightedScale
    }, {
      name: 'Streaming Swap',
      description: 'Reduce slippage by swapping smaller amounts over time.',
      advanced: false,
      enabled: true,
      icon: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
        stroke: "white",
        strokeWidth: "px",
        as: index_esm/* FiAperture */.Ry6,
        width: 8,
        height: 8
      }),
      href: StrategyUrls/* default.StreamingSwap */.Z.StreamingSwap,
      learnMoreHref: LearningHubLinks/* LearningHubLinks.MoreAboutCalc */.B.MoreAboutCalc
    }];
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(stack/* Stack */.K, {
    direction: "column",
    spacing: 8,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(stack/* Stack */.K, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Wrap, {
        spacing: 2,
        pb: 1,
        shouldWrapChildren: true,
        align: "center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(heading/* Heading */.X, {
          size: "md",
          children: "Accumulation strategies"
        }), showFearAndGreedAccumulate && /*#__PURE__*/(0,jsx_runtime.jsx)(FearGreedStrategyRecommendation, {
          isAccumulation: true
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(flex/* Flex */.k, {
        gap: 8,
        flexDirection: "row",
        wrap: "wrap",
        children: accumulationStrategies().map(function (strategy) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(StrategyCard, _objectSpread({}, strategy), strategy.name);
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(InfoPanel, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(stack/* Stack */.K, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Wrap, {
        spacing: 2,
        pb: 1,
        shouldWrapChildren: true,
        align: "center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(heading/* Heading */.X, {
          mb: 1,
          size: "md",
          children: "Take Profit strategies"
        }), showFearAndGreedProfit && /*#__PURE__*/(0,jsx_runtime.jsx)(FearGreedStrategyRecommendation, {})]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(flex/* Flex */.k, {
        gap: 8,
        flexDirection: "row",
        wrap: "wrap",
        children: takeProfitStrategies().map(function (strategy) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(StrategyCard, _objectSpread({}, strategy), strategy.name);
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(stack/* Stack */.K, {
      direction: "row",
      layerStyle: "panel",
      p: 4,
      spacing: 4,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(image_image/* Image */.E, {
        src: "/images/moneyBag.svg"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(flex/* Flex */.k, {
        alignItems: "center",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(typography_text/* Text */.x, {
          textStyle: "body",
          children: "Set your profit taking goals when accumulating an asset, because when assets start pumping, euphoria kicks in."
        })
      })]
    })]
  });
}

function CreateStrategy() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(stack/* Stack */.K, {
    direction: "column",
    spacing: 8,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(stack/* Stack */.K, {
      spacing: 2,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(heading/* Heading */.X, {
        size: "lg",
        children: "Set up a smart swap strategy"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(typography_text/* Text */.x, {
        textStyle: "body",
        children: "The smartest way to enter and exit positions, complimented with pre- and post-swap automation to save time and counter emotional decision making."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Strategies, {})]
  });
}

CreateStrategy.getLayout = Layout/* getSidebarLayout */.M;
/* harmony default export */ var index_page = (CreateStrategy);

/***/ }),

/***/ 84206:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create-strategy",
      function () {
        return __webpack_require__(9341);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 74032:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ Badge; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_styled_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65544);
/* harmony import */ var _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34926);
/* harmony import */ var _system_forward_ref_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49381);
/* harmony import */ var _system_use_style_config_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73035);
/* harmony import */ var _system_factory_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17997);
'use client';







const Badge = (0,_system_forward_ref_mjs__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .G)(function Badge2(props, ref) {
  const styles = (0,_system_use_style_config_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useStyleConfig */ .m)("Badge", props);
  const { className, ...rest } = (0,_chakra_ui_styled_system__WEBPACK_IMPORTED_MODULE_3__/* .omitThemingProps */ .L)(props);
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _system_factory_mjs__WEBPACK_IMPORTED_MODULE_4__/* .chakra.span */ .m.span,
    {
      ref,
      className: (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_5__.cx)("chakra-badge", props.className),
      ...rest,
      __css: {
        display: "inline-block",
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        ...styles
      }
    }
  );
});
Badge.displayName = "Badge";




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(84206); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);